import {
  Button,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { SidebarPanel } from '../SidebarPanel';

export const PopularCompetitions: React.FC = (): JSX.Element => {
  const navigate = useNavigate();

  const competitions = [
    { id: 1, naam: 'KKG 100m Optiek', deelnemers: 32 },
    { id: 2, naam: 'Karabijn 50m 2026', deelnemers: 22 },
    { id: 3, naam: 'Service Pistool 2026', deelnemers: 20 },
  ];

  const onClick = (): void => {
    navigate('/competitions/current/332');
  };

  return (
    <SidebarPanel title="🔥 Populaire Competities">
      <List>
        {competitions.map((competition, index) => (
          <ListItem
            key={competition.id}
            divider={index < competitions.length - 1}
          >
            <ListItemText
              primary={competition.naam}
              secondary={`${competition.deelnemers} deelnemers`}
            />
            <ListItemSecondaryAction>
              <Button variant="outlined" size="small" onClick={onClick}>
                Bekijk
              </Button>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </SidebarPanel>
  );
};
